export function updateSelectedDates( selectedDatesHolder )
{
	if( selectedDatesHolder.length !== 0 )
	{
		if( !$('select[name=ankomst]').hasClass('highlight') )
		{
			$('select[name=ankomst]').addClass('highlight');
		}
	}

	if( selectedDatesHolder.length === 1 )
	{
		$('#dateSelect option[value='+selectedDatesHolder[0]+']').prop('selected',true);
	}
}
